<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="row">
  <div class="col-12" *ngIf="mostrarFormulario">
    <app-card cardTitle="Cadastro de FAQ" [options]="false">
      <div class="row">
        <div class="col-md-8">
          <label class="sub-title">Pergunta <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="pergunta" name="pergunta" placeholder="Digite a pergunta">
        </div>
        <div class="col-md-2">
          <label class="sub-title">Ordem <span class="text-danger">*</span></label>
          <input type="number" class="form-control" [(ngModel)]="ordem" name="ordem" placeholder="1" min="1">
        </div>
        <div class="col-md-2 text-left">
          <div class="form-group">
            <label class="sub-title">Status</label>
            <div class="switch switch-success d-inline m-r-10">
              <input type="checkbox" id="switch-status-faq" [(ngModel)]="status" name="status">
              <label for="switch-status-faq" class="cr"></label>
            </div>
            <label>{{status ? 'Ativo' : 'Inativo'}}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="sub-title">Programa (Opcional)</label>
          <ng-select [ngClass]="'tag-select'" [options]="arrayProgramas" [(ngModel)]="programaSelecionado"
            placeholder="Selecione um programa (opcional)">
          </ng-select>
          <small class="form-text text-muted">Deixe em branco para FAQ geral ou selecione um programa específico</small>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12">
          <label class="sub-title">Resposta <span class="text-danger">*</span></label>
          <app-tinymce [(ngModel)]="resposta" name="resposta" #tinymce='tinymce'></app-tinymce>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-right" *ngIf="faqSelecionado == null">
          <br>
          <button type="button" class="btn btn-secondary" (click)="fecharFormulario()">
            <i class="fa fa-times"></i> &nbsp; CANCELAR
          </button>&nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-success" (click)="salvar()">
            SALVAR &nbsp;<i class="feather icon-check-circle"></i>
          </button>
        </div>
        <div class="col-sm-12 text-right" *ngIf="faqSelecionado != null">
          <br>
          <button type="button" class="btn btn-secondary" (click)="fecharFormulario()">
            <i class="fa fa-times"></i> &nbsp; CANCELAR
          </button>&nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-warning" (click)="limpar()">
            <i class="fa fa-arrow-left"></i> &nbsp; LIMPAR PARA ADICIONAR NOVO
          </button>&nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-info" (click)="alterar()">
            ATUALIZAR &nbsp;<i class="feather icon-check-circle"></i>
          </button>
        </div>
      </div>
    </app-card>
  </div>

  <div class="col-12">
    <app-card cardTitle="FAQs Cadastrados" blockClass="table-border-style" [options]="false">
      <div class="row mb-3" *ngIf="!mostrarFormulario">
        <div class="col-12">
          <button type="button" class="btn btn-primary" (click)="abrirFormulario()">
            <i class="feather icon-plus-circle"></i> &nbsp; ADICIONAR NOVO FAQ
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Ordem</th>
              <th>Pergunta</th>
              <th>Programa</th>
              <th>Status</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of arrayFaqs">
              <td>{{item.ordem}}</td>
              <td>{{item.pergunta}}</td>
              <td>
                <span *ngIf="item.iD_PROGRAMA" class="badge badge-primary">{{item.programA_NOME}}</span>
                <span *ngIf="!item.iD_PROGRAMA" class="badge badge-secondary">Geral</span>
              </td>
              <td>
                <span *ngIf="item.status == 1" class="badge badge-success">ATIVO</span>
                <span *ngIf="item.status == 0" class="badge badge-danger">INATIVO</span>
              </td>
              <td>
                <button type="button" class="btn btn-icon btn-info" (click)="carregarItem(item)">
                  <i class="fa fa-edit"></i>
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-icon btn-danger" (click)="desabilitar(item.iD_FAQ)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
</div>
